const Auth0RolesTypes = {
  admin: 'support-admin',
  manager: 'manager',
};

export const isAdmin = (rol: string) => rol === Auth0RolesTypes.admin;

export const isManager = (rol: string) => rol === Auth0RolesTypes.manager;
